import { Component, OnInit } from '@angular/core';

import { GrupoMaterialService } from "../shared/grupo-material.service";
import { UtilService } from "../../../shared/services/util.service";
import { FilterService } from "../../../shared/services/filter.service";
import { GrupoMaterial } from "../shared/grupo-material.model";
import { gruposMateriaisModuleName, subgruposMateriaisModuleName, grupoMaterialCodigoMask } from "../shared/data.service";
import { contaContabilCodigoMask } from "../../../contas/conta-contabil/shared/data.service";
import { GrupoMaterialApiService } from "../shared/grupo-material-api.service";
import { GrupoMaterialNavigationService } from "../shared/grupo-material-navigation.service";

declare var swal: any;

@Component({
  template: require('./grupo-material-list.component.html')
})

export class GrupoMaterialListComponent implements OnInit {
  gruposMateriaisModuleName: any = gruposMateriaisModuleName;
  subgrupoMaterialModuelName: any = subgruposMateriaisModuleName;
  list: Array<any> = [];
  showDisabled: boolean = false;
  loading: boolean = true;
  codigoMask: number = grupoMaterialCodigoMask;
  contaContabilCodigoMask: number = contaContabilCodigoMask;

  constructor(
    private _grupoMaterialService: GrupoMaterialService,
    private _grupoMaterialApiService: GrupoMaterialApiService,
    private _grupoMaterialNavigationService: GrupoMaterialNavigationService,
    private _utilService: UtilService,
    private _filterService: FilterService
  ){}

  ngOnInit() {
    this.getAll();
  }

  clickNew() {
    this._grupoMaterialService.clearSessionStorage();
    this._grupoMaterialNavigationService.goToNew();
  }

  clickEdit(item: GrupoMaterial) {
    this._grupoMaterialService.clearSessionStorage();
    this._grupoMaterialNavigationService.goToEdit(item.id);
  }

  clickDelete(item: GrupoMaterial) {
    var onDelete = (function() {
      this.onDelete(item);
    }.bind(this));

    this._utilService.swalMessageDelete(onDelete);
  }

  clickAddSubgrupo(grupo: any) {
    this._grupoMaterialService.clearSessionStorage();
    this._grupoMaterialNavigationService.goToAddSubgrupo(grupo.id);
  }

  clickEditSubgrupo(grupo: any, subgrupo: any) {
    this._grupoMaterialService.clearSessionStorage();
    this._grupoMaterialNavigationService.goToEditSubgrupo(grupo.id, subgrupo.id);
  }

  private getAll() {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        let list: any[] = Response;
        var subgrupos: any[] = [],
          listClone: any[] = [],
          itemId: string;

        Response.forEach(function(item: any) {
          if (!item.grupoId) {
            itemId = item.id.toString();
            subgrupos = this._filterService.filterArray(list, item.id, ['grupoId']);
            item.subgrupos = subgrupos;
            listClone.push(item);
          }
          subgrupos = [];
        }.bind(this));

        this.list = listClone;
      }
      this.loading = false;
    }.bind(this));

    this._grupoMaterialApiService.onGetAll(onDone);
  }

  private onDelete(item: any) {
    var onDone = (function (Response: any) {
      if (!Response.error) {

        if (item.grupoId) {
          this.disabledSubgrupo(item);
        } else {
          this.disabledGrupo(item);
        }

        this._utilService.swalMessageDeleteSuccess();
      } else {
        this._utilService.swalMessageDeleteError();
      }
    }.bind(this));

    this._grupoMaterialApiService.onDelete(item.id, onDone);
  }

  private disabledGrupo(item: any) {
    var x: number, lenX: number;
    for (x = 0, lenX = this.list.length; x < lenX; x++) {
      if (this.list[x].id === item.id) {
        this.list[x].ativo = false;
        break;
      }
    }
  }

  private disabledSubgrupo(item: any) {
    var x: number, lenX: number, grupoIndex: number;
    for (x = 0, lenX = this.list.length; x < lenX; x++) {
      if (this.list[x].id === item.grupoId) {
        grupoIndex = x;
        break;
      }
    }

    for (x = 0, lenX = this.list[grupoIndex].subgrupos.length; x < lenX; x++) {
      if (this.list[grupoIndex].subgrupos[x].id === item.id) {
        this.list[grupoIndex].subgrupos[x].ativo = false;
        break;
      }
    }
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/grupos-materiais/grupo-material-list/grupo-material-list.component.ts
 **/